import Loading from "@builder/components/app/Loading";
import { useTranslation } from "react-i18next";
import "./style.scss";

interface LoaderButttonProps {
    onClick: () => void;
    text: string;
    isLoading: boolean;
    styles?: React.CSSProperties;
}

const LoaderButton = ({ onClick, text, isLoading, styles }: LoaderButttonProps) => {
    const { t } = useTranslation();

    return (
        <button className="loader-button" onClick={onClick} style={styles}>
            {text && <div>{t("generalComponents.button." + text)}</div>}
            {isLoading && (
                <div className="iframe-loading">
                    <Loading noText notFullscreen />
                </div>
            )}
        </button>
    );
};

export default LoaderButton;
